import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v2/transactions/" });

export const TransactionService = {
  getTransaction: (id) => {
    return api.get(`${id}`);
  },

  createTransaction: (payload) => {
    return api.post(payload);
  },

  updateTransaction: (id, payload) => {
    return api.put(`${id}`, payload);
  },

  addPayment: (paymentData) => {
    return api.post("add-payment", paymentData);
  },

  updateSubContractorPayment: (transactionId, paymentData) => {
    return api.put(`update-payment/${transactionId}`, paymentData);
  },
};
